module.exports = __webpack_public_path__ + "8afec022c36d234156e0dfe103b88c11.ttf";